import React, { useEffect, useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import {
  getMyApplications,
  withdrawMyApplication,
  exportMyApplicationPDF,
} from "../../../services/job-applications";
import { useNavigate } from "react-router-dom";
import "../styles/ApplicationsTable.css";

const MyApplications = () => {
  const { token } = useAuth();
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState("");
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    getMyApplications(token, statusFilter)
      .then((res) => setApplications(res.data))
      .catch(() => setApplications([]))
      .finally(() => setLoading(false));
  }, [token, statusFilter]);

  const handleWithdraw = async (appId) => {
    try {
      await withdrawMyApplication(token, appId);
      setApplications(applications.filter((app) => app.id !== appId));
      setSuccess("Application withdrawn.");
    } catch (e) {
      setError("Failed to withdraw application.");
    }
  };

  const handleExportPDF = async (appId) => {
    try {
      const res = await exportMyApplicationPDF(token, appId);
      const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      window.open(url);
    } catch {
      setError("Unable to export PDF.");
    }
  };

  return (
    <div className="ma-shell">
      <div className="ma-card">
        <div className="ma-head">
        
          <div className="ma-filters">
            <label className="ma-label">Status</label>
            <select
              className="ma-select"
              onChange={(e) => setStatusFilter(e.target.value)}
              value={statusFilter}
            >
              <option value="">All</option>
              <option value="PENDING">Pending</option>
              <option value="ACCEPTED">Accepted</option>
              <option value="REJECTED">Rejected</option>
              <option value="WITHDRAWN">Withdrawn</option>
            </select>
          </div>
        </div>

        {success && <div className="ma-alert ma-alert--success">{success}</div>}
        {error && <div className="ma-alert ma-alert--error">{error}</div>}

        {loading ? (
          <div className="ma-empty">Loading...</div>
        ) : applications.length === 0 ? (
          <div className="ma-empty">No applications found</div>
        ) : (
          <div className="ma-tableWrap">
            <table className="ma-table">
              <thead>
                <tr>
                  <th>Job Title</th>
                  <th>Status</th>
                  <th>Date Applied</th>
                  <th className="ma-actionsCol">Actions</th>
                </tr>
              </thead>

              <tbody>
                {applications.map((app) => (
                  <tr key={app.id}>
                    <td className="ma-jobTitle">{app.job?.title || "—"}</td>

                    <td>
                      <span className={`ma-status ma-status--${String(app.status || "").toLowerCase()}`}>
                        {app.status || "—"}
                      </span>
                    </td>

                    <td>{app.createdAt ? new Date(app.createdAt).toLocaleDateString() : "—"}</td>

                    <td className="ma-actions">
                      <button
                        className="ma-btn ma-btn--primary"
                        onClick={() => navigate(`/applications/${app.id}`)}
                      >
                        View Details
                      </button>

                      {app.status === "PENDING" && (
                        <button className="ma-btn ma-btn--danger" onClick={() => handleWithdraw(app.id)}>
                          Withdraw
                        </button>
                      )}

                      <button className="ma-btn ma-btn--ghost" onClick={() => handleExportPDF(app.id)}>
                        Download PDF
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default MyApplications;
